import { configureStore, getDefaultMiddleware } from "@reduxjs/toolkit";

import registerReducer from "./Features/Register/registerSlice";
import forgetPasswordReducer from "./Features/Password/passwordSlice";
import tfaSettingReducer from "./Features/TfaSettings/tfaSettingslice";
import siteSettingReducer from "./Features/SiteSettings/siteSettingSlice";
import contactusReducer from "./Features/contactus/contactusSlice";
import transactionReducer from "./Features/Transaction/transactionSlice";
import walletReducer from "./Features/WalletDetails/walletBalanceSlice";
import bankreducer from "./Features/Bankdetails/bankDetailsSlice"

import kycReducer from "./Features/KYC/kycSlice";

import historyreducer from "./Features/CrashBetFunction/crashSlice"

import socialLoginReducer from "./Features/SocialLogin/socialLoginSlice";

import linkEmailReducer from "./Features/LinkEmail/linkEmailSlice";
import gameReducer from "./Features/GameCommon/gameCommonSlice";

import statisticsReducer from "./Features/Statistics/statisticsSlice";

import crashBetReducer from "./Features/CrashBetFunction/crashSlice";







const store = configureStore({
    reducer: {
        register: registerReducer,
        forget: forgetPasswordReducer,
        tfaSettings: tfaSettingReducer,
        siteSettings: siteSettingReducer,
        kycDetails: kycReducer,
        socialLogin: socialLoginReducer,
        contactus: contactusReducer,
        linkEmail: linkEmailReducer,
        game: gameReducer,
        transaction: transactionReducer,
        statistics: statisticsReducer,
        wallet: walletReducer,
        crashBet: crashBetReducer,
        bankdata: bankreducer,
        crashhistory: historyreducer
    },
})

export default store;
